import React from "react";
import PropTypes from "prop-types";
// import { Link } from "react-router-dom";

const WorkItem = ({ portfolio }) => {
  return (
    <div className="single-portfolio">
      <div className="thumbnail">
        <a href={portfolio.homeImage} target="_blank" rel="noopener noreferrer">
          <img
            src={portfolio.homeImage}
            alt={portfolio.title || "Historical photo"}
            decoding="async"
            loading="lazy"
          />
        </a>
      </div>
      {/* <div className="content">
        <h5 className="title">
          <Link to={process.env.PUBLIC_URL + `/work-details/${portfolio.id}`}>
            {`${portfolio.title.slice(0, 22)}...`}{" "}
            <img
              src={process.env.PUBLIC_URL + "/images/icons/arrow-up-right.svg"}
              alt=""
            />
          </Link>
        </h5>
      </div> */}
    </div>
  );
};

WorkItem.propTypes = {
  portfolio: PropTypes.object,
};

export default WorkItem;
